import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const TextAreaFieldFroup = ({
  label,
  name,
  placeholder,
  value,
  error,
  info,
  onChange,
  rows
}) => {
  return (
    <div className="form-group">
      <label className="control-label">{label}</label>
      <textarea
        className={classnames('form-control form-control-lg', {
          'is-invalid': error
        })}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
      />
      {info && <small className="form-text text-muted">{info}</small>}
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

TextAreaFieldFroup.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  info: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  label: PropTypes.string
};

export default TextAreaFieldFroup;
